import {apiClient} from 'core/apiClient';

import {Cluster, ClustersRequest} from 'types/geo';

export async function getClusters(payload: ClustersRequest) {
    const path = '/epcis/tracking/clusters';
    return (await apiClient.get<Cluster[]>(path, {headers: payload})).data;
}
